import { render, staticRenderFns } from "./store-confirm.vue?vue&type=template&id=b1f95bc2&scoped=true"
import script from "./store-confirm.vue?vue&type=script&lang=js"
export * from "./store-confirm.vue?vue&type=script&lang=js"
import style0 from "./store-confirm.vue?vue&type=style&index=0&id=b1f95bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f95bc2",
  null
  
)

export default component.exports